import { ArrowRight, MapPin } from "lucide-react";
import { BUSINESS } from "@/lib/api";

export const HeroSection = () => (
  <section className="relative overflow-hidden bg-[#0E1F3F] pt-20 text-white">
    <div className="absolute inset-0 opacity-25">
      <img src="/images/custom_home_estate.jpg" alt="" className="h-full w-full object-cover" />
    </div>
    <div className="absolute inset-0 bg-gradient-to-r from-[#0E1F3F] via-[#0E1F3F]/90 to-[#0E1F3F]/40" />
    <div className="relative mx-auto grid max-w-7xl items-end gap-6 px-4 pt-12 sm:px-6 lg:grid-cols-12 lg:px-12">
      <div className="pb-14 lg:col-span-7 lg:pb-24">
        <p className="eyebrow rise mb-5 flex items-center gap-2 !text-[#F2B91C]"><MapPin size={14} />Lucerne Valley · High Desert, CA</p>
        <h1 className="font-display rise rise-1 text-4xl font-extrabold leading-[1.02] tracking-tight sm:text-5xl lg:text-6xl">
          Custom homes &amp; concrete, <span className="font-serif-accent font-normal text-[#F2B91C]">built upon the rock.</span>
        </h1>
        <p className="rise rise-2 mt-6 max-w-xl text-base leading-relaxed text-white/75 sm:text-lg">
          {BUSINESS.name} LLC builds custom homes and pours custom concrete across the High Desert — with clear estimates, honest invoices and a customer portal that keeps you updated every step.
        </p>
        <div className="rise rise-3 mt-9 flex flex-wrap gap-3">
          <a href="#estimate" data-testid="hero-estimate-cta" className="group inline-flex items-center gap-2 rounded-full bg-[#F2B91C] px-6 py-3.5 text-sm font-bold text-[#0E1F3F] transition-colors hover:bg-white">
            Get a free estimate <ArrowRight size={16} className="transition-transform group-hover:translate-x-1" />
          </a>
          <a href={BUSINESS.phoneHref} data-testid="hero-call-btn" className="inline-flex items-center rounded-full border border-white/40 px-6 py-3.5 text-sm font-semibold transition-colors hover:border-white hover:bg-white hover:text-[#0E1F3F]">
            Call or text {BUSINESS.phone}
          </a>
        </div>
        <p className="rise rise-4 mt-10 font-serif-accent text-lg text-white/70">Strong Faith. Firm Foundations. Endless Integrity.</p>
      </div>
      <div className="relative flex justify-center lg:col-span-5 lg:justify-end">
        <img src="/brand/mascot_web.png" alt="Firm Foundations builder" data-testid="hero-mascot" className="rise rise-2 relative z-10 h-[360px] w-auto drop-shadow-2xl sm:h-[480px] lg:h-[560px]" />
      </div>
    </div>
  </section>
);
